// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"596dcda14fd581d2","9266":"724f1cf59810e413"}[chunkId] + ".css";
};